










import Topbar from "@/components/TheTopbar.vue";
import Sidebar from "@/components/TheSidebar.vue";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({ components: { Topbar, Sidebar } })
export default class Container extends Vue {}
